import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import Moment from "moment";
import { searchCrewMgmt } from "../Actions/CrewManagement";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import CrewList from "./ShipDetailsCrewCard";
import { getShipnameList } from "../Actions/HelpersAPI";
import { getClientShipDetails } from "../Actions/CommonAPI";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";
import Role from "../helpers/role";
import axios from "axios";
import API from "../helpers/api";

let userRole = localStorage.getItem("UserRoles");
let user = JSON.parse(localStorage.getItem("currentUser"));



class ComapnyShipDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        crewId: "",
        name: "",
        shipName: "",
        shipId: 0,
        clientId: 0,
        fromDate: "",
        toDate: "",
        designation: "",
        PageNumber: 1,
        PageSize: 25,
      },
    };
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    if (id) {
      this.state.searchData.shipId = id;
      this.setState({}, () => {
        dispatch(getClientShipDetails(parseInt(this.state.searchData?.shipId)));
        dispatch(searchCrewMgmt(this.state.searchData, 1));
      });
    }
    if (userRole === Role.staff) {
      let url = `${API.shipNames}?email=${user.email}`;
      axios.get(url)
        .then((response) => {
          this.state.searchData.shipId = response.data[0].shipID;
          this.setState({
          }, () => {
            dispatch(getClientShipDetails(parseInt(this.state.searchData?.shipId)));
            dispatch(searchCrewMgmt(this.state.searchData, 1));
          })
        })
    }
    dispatch({ type: "SubBannerTitle", data: "Ship Details" });

  }
  BacktoPrevious() {
    this.props.history.goBack();
  }
  SearchData(Pgno) {
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(searchCrewMgmt(this.state.searchData, Pgno));
  }
  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }
  ClearInput() {
    let param = {
      crewId: "",
      name: "",
      shipName: "",
      fromDate: "",
      toDate: "",
      designation: "",
      shipId: this.state.searchData.shipId,
      clientId: 0,
      PageNumber: this.state.searchData.PageNumber,
      PageSize: this.state.searchData.PageSize
    };
    this.setState(
      {
        searchData: param,
      },
      () => {
        this.props.dispatch(searchCrewMgmt(this.state.searchData, 1));
      }
    );
  }
  renderPopover(props) {
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            Callibration due is expired.
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  render() {
    const { ClientShipDetailsList, SearchCrew, showSidePane } = this.props;

    return (
      <div className="full-height">
        <div className="grey-bg  course-list-page">
          <div className="pt-3">

            {userRole == Role.staff ? (<></>) : (
              <div className="row px-3 pb-3">
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  onClick={() => this.BacktoPrevious()}
                >
                  <div style={{ position: 'relative' }}>
                    <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                  </div>
                </button>
              </div>
            )}
            <div
              className="card MM-card-header m-auto"
              style={{ backgroundColor: "white" }}
            >
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1a3464",
                  color: "white",
                }}
              >
                <h5
                  className="card-title ml-3 mt-2"
                  style={{ color: "092a51" }}
                >
                  Ship Details
                </h5>
              </div>
            </div>
            <div className="panel-box  search-filter-box mb-3">
              <div className="row" style={{ paddingBottom: "12px" }}>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Ship Name : </strong>
                    <span className="italicFont">
                      {" "}
                      {ClientShipDetailsList
                        ? ClientShipDetailsList?.shipName
                        : ""}
                    </span>
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Ship Email : </strong>
                    {ClientShipDetailsList &&
                      ClientShipDetailsList?.shipMail ?
                      <span className="">
                        {" "}
                        {ClientShipDetailsList?.shipMail}
                      </span> : <span className="italic">
                        {"Not" + " " + "Assigned"}
                      </span>
                    }
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>IMO No : </strong>
                    <span className="italicFont">
                      {" "}
                      {ClientShipDetailsList ? ClientShipDetailsList.imoNo : ""}
                    </span>
                  </span>
                </div>
                <div className="col-sm-12 col-md-12 py-2">
                  <strong>Assigned mailid for communicating failure results</strong>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Primary Email :  </strong>
                    {ClientShipDetailsList &&
                      ClientShipDetailsList?.tomailforalert ?
                      <span className="italicFont">
                        {" "}
                        {ClientShipDetailsList?.tomailforalert}
                        {" "}
                      </span>
                      : <span className="italic">
                        {"Not" + " " + "Assigned"}
                      </span>}
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>CcEmail :  </strong>
                    {ClientShipDetailsList &&
                      ClientShipDetailsList?.ccmailforalert ?
                      <span className="italicFont">
                        {ClientShipDetailsList?.ccmailforalert}

                      </span>
                      : <span className="italic">
                        {"Not" + " " + "Assigned"}
                      </span>}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="pt-2">
            <div
              className="card MM-card-header m-auto"
              style={{ backgroundColor: "white" }}
            >
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1a3464",
                  color: "white",
                }}
              >
                <h5
                  className="card-title ml-3 mt-2"
                  style={{ color: "092a51" }}
                >
                  Company Details
                </h5>
              </div>
            </div>
            <div className="panel-box  search-filter-box mb-3">
              <div className="row" style={{ paddingBottom: "12px" }}>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Company Name : </strong>
                    <span className="italicFont">
                      {" "}
                      {ClientShipDetailsList
                        ? ClientShipDetailsList?.name
                        : ""}{" "}
                    </span>
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Email : </strong>
                    <span className="italicFont"> {" "}{ClientShipDetailsList
                      ? ClientShipDetailsList?.clientEmail : ""}{" "}</span>
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Phone : </strong>
                    <span className="italicFont">{" "}{ClientShipDetailsList
                      ? ClientShipDetailsList?.phone : ""}{" "} </span>
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Address : </strong>
                    <span className="italicFont">{" "}{ClientShipDetailsList
                      ? ClientShipDetailsList?.address : ""}{" "} </span>
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>Marine Manager Email : </strong>
                    <span className="italicFont"> {" "}{ClientShipDetailsList
                      ? ClientShipDetailsList?.fleetManager : ""}{" "}</span>
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>  Marine Superintendent Email : </strong>
                    <span className="italicFont">{" "}{ClientShipDetailsList
                      ? ClientShipDetailsList?.technicalSuperintendent : ""}{" "} </span>
                  </span>
                </div>
                <div className="col-sm-4 col-md-4 py-2">
                  <span>
                    <strong>DPA Email : </strong>
                    <span className="italicFont">{" "}{ClientShipDetailsList
                      ? ClientShipDetailsList?.technicalExecutive : ""}{" "} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="pt-2">
            <div
              className="card MM-card-header m-auto"
              style={{ backgroundColor: "white" }}
            >
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1a3464",
                  color: "white",
                }}
              >
                <h5
                  className="card-title ml-3 mt-2"
                  style={{ color: "092a51" }}
                >
                  Device Details
                </h5>
              </div>
            </div>
            <div className="panel-box  search-filter-box mb-3">
              <div className="search-filter-box pt-2">
                {ClientShipDetailsList?.deviceDetails.length !== 0 ? (
                  ClientShipDetailsList?.deviceDetails.map((item, index) => {
                    return (
                      <div
                        className="card click"
                        style={{
                          backgroundColor: "#f0f0f0",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <div className="p-3">
                          <div className="resource-list-auth-date">
                            <div className="row">
                              <div className="col-sm-11 col-md-11 col-lg-11">
                                <div className="row">
                                  <div className="col-sm-4 col-md-4 py-2">
                                    <span>
                                      <strong>ID : </strong>
                                      <span className="italicFont">
                                        {item ? item?.id : ""}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-4 col-md-4 py-2">
                                    <span>
                                      <strong>Make : </strong>
                                      <span className="italicFont">
                                        {item ? item?.make : ""}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-4 col-md-4 py-2">
                                    <span>
                                      <strong>Model : </strong>
                                      <span className="italicFont">
                                        {item ? item?.model : ""}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-4 col-md-4 py-2">
                                    <span>
                                      <strong>Manufacturing Date : </strong>
                                      <span className="italicFont">
                                        {item
                                          ? Moment(
                                            new Date(
                                              Date.parse(item.manufacturingDate)
                                            )
                                          ).format("DD MMM YYYY")
                                          : ""}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-4 col-md-4 py-2">
                                    <span>
                                      <strong>Last Calibration Date : </strong>
                                      <span className="italicFont">
                                        {item
                                          ? Moment(
                                            new Date(
                                              Date.parse(
                                                item.lastCalibrationDate
                                              )
                                            )
                                          ).format("DD MMM YYYY")
                                          : ""}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-4 col-md-4 py-2">
                                    <span>
                                      <strong>Next Calibration Date : </strong>
                                      <span className="italicFont">
                                        {item
                                          ? Moment(
                                            new Date(
                                              Date.parse(
                                                item.nextCalibrationDate
                                              )
                                            )
                                          ).format("DD MMM YYYY")
                                          : ""}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="col-sm-4 col-md-4 py-2">
                                    <span>
                                      <strong>Last Device Sync Date : </strong>
                                      <span className="italicFont">
                                        {item?.isDeviceSynched && item?.lastSync
                                          ? Moment.utc(item.lastSync).format("DD MMM YYYY k:mm " + " " + "UTC")
                                          : "-"}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-1 col-md-1 col-lg-1 col-m-auto text-right">
                                <div
                                  className="m10"
                                  style={{
                                    marginLeft: "10px",
                                    MarginTop: "1rem",
                                  }}
                                >
                                  {item.isExpired ? (
                                    <OverlayTrigger
                                      placement="bottom"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={this.renderPopover()}
                                    >
                                      <i
                                        className="fa fa-exclamation-triangle click px-2"
                                        aria-hidden="true"
                                        style={{
                                          color: "#d41616f5",
                                          fontSize: "1.6rem",
                                        }}
                                      ></i>
                                    </OverlayTrigger>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    className="card"
                    style={{ overflow: "hidden", position: "relative" }}
                  >
                    <div class="container">
                      <h6 className="resource-list-title no-item-card">
                        !-- No Device to Display --!
                      </h6>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="pt-2">
            <div
              className="card MM-card-header m-auto"
              style={{ backgroundColor: "white" }}
            >
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1a3464",
                  color: "white",
                }}
              >
                <h5
                  className="card-title ml-3 mt-2"
                  style={{ color: "092a51" }}
                >
                  Crew Details
                </h5>
              </div>
            </div>
            <div className="panel-box  search-filter-box mb-3">
              <div className="search-filter-box pt-2">

                <div className="row pb-3">
                  <div className="col-lg-4" >
                    <label className="form-label">Crew Id</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="crewId"
                      placeholder="Crew Id"
                      value={this.state.searchData.crewId}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Name</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={this.state.searchData.name}
                      onChange={(e) => this.handleInputChange(e)}
                    ></input>
                  </div>
                  <div className="col-lg-4">
                    <label className="mt-4"></label>
                    <br></br>
                    <div
                      className="search-btn-col"
                      style={{ textAlign: "end" }}>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.SearchData(1)} >
                        {" "}
                        Search{" "}
                      </button>

                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button"
                        onClick={() => this.ClearInput()}>
                        {" "}
                        Clear{" "}
                      </button>
                    </div>
                  </div>
                </div>

                {SearchCrew ? (
                  <CrewList
                    arraylist={SearchCrew.data}
                    pageSize={SearchCrew.pagination.pageSize}
                    currentPage={SearchCrew.pagination.currentPage}
                    totalRecords={
                      SearchCrew.pagination.totalcount
                        ? SearchCrew.pagination.totalcount
                        : 0
                    }
                    setUpdatedState={(value) => this.SearchData(value)}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    SearchCrew: state.CrewManagementReducer.SearchCrew,
    showSidePane: state.SidePanReducer.sidePan || false,
    ClientShipDetailsList: state.MasterScreenReducer.ClientShipDetailsList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ComapnyShipDetails)
);
